export default __webpack_public_path__ + "static/2024-img-articolo-novembre1-a542a8fbca41d34841385315537937a5.jpg";